import React from 'react';
import caretRight from '../../../assets/images/icons/caret-right-blue.svg';
import checkmark from '../../../assets/images/icons/checkmark.svg';
import arrowRight from '../../../assets/images/icons/arrow-right.svg';
import Styles from './InsightMenuItem.module.scss';

const InsightMenuItem = (props) => {
  const {
    isActive,
    icon,
    menuItem,
    onClick,
    isTileView,
  } = props;

  const menuItemColorStyling = isActive ? Styles.active : Styles.inactive;
  return (
    <button type='button'
      className={`${Styles.menuItem} ${!isTileView ? menuItemColorStyling : ''}`} onClick={onClick}>
      <div className={Styles.largeIcon}><img className={Styles.icon} src={icon} alt='large-icon' /></div>
      <div className={Styles.menuText}>
        <div className={Styles.menuTitle}>{menuItem.menuTitle}</div>
        <div className={Styles.menuDescription}>
          <img className={Styles.smallIcon} src={menuItem.checked ? checkmark : arrowRight} alt='small-icon' />
          {menuItem.menuDescription}
        </div>
      </div>
      <div className={Styles.caretRight}><img src={caretRight} alt='caret-right' /></div>
    </button>
  );
};

export default InsightMenuItem;
